import React from 'react';
import './Site.scss';
//COMPONENTS
import AllowedRoutes from './AllowedRoutes/AllowedRoutes';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';

const Site = () => {
    //STATES
    const [isOpened, setIsOpened] = React.useState(false);

    return (
        <div id="Site">
            <Sidebar {...{ isOpened, setIsOpened }} />

            <div id="content">
                <Header {...{ isOpened }} />
                <AllowedRoutes />
            </div>
        </div>
    );
};
export default React.memo(Site);